//
//
//
//
//
//

export default {
  name: 'detail-prefill',
  methods: {
    click: function click() {
      this.$emit('click');
    }
  },
  mounted: function mounted() {
    this.$emit('mounted');
  }
};